import $ from "jquery";
import validation from "../../abstracts/validation";
import route from '../../helpers/route';

const componentBookingForm = () => {
  const init = () => {
    execute();
    executeBack();
  };

  const execute = () => {
    const el = {
      main: ".js-booking-form",
      step: ".js-booking-step",
      detail: ".js-booking-detail",
      payment: ".js-booking-form-payment",
    };

    if ($(el.main).length === 0) return;
    const { onInput, onSubmit } = validation();

    $(document).on("submit", el.main, function (e) {
      e.preventDefault();
      const isValid = onSubmit(e, $(this));
      if (!isValid) return;

      const stepValue = $(this).data("value_step");
      const stepChecked = $(this).data("value_checked");

      $(el.step).attr("aria-valuetext", stepValue);
      $(el.step).attr("aria-checked", stepChecked);

      const detailTitle = $(`${el.detail} .js-booking-detail_title`).data(
        "step-2"
      );
      // $(`${el.detail} .js-booking-form-click`).attr(
      //   "data-step_value",
      //   "step-2"
      // );
      $(`${el.detail} .js-booking-detail_title`).text(detailTitle);

      const formData = new FormData(this);

      /* eslint no-undef: 'off' */
      const ajaxConfig = themeObj.client_book_room;
      formData.append('action', ajaxConfig.action)
      formData.append('nonce', ajaxConfig.nonce)
      formData.append('room_id', route.get('room_key'))
      formData.append('date', route.get('date_filter'))
      formData.append('slot_bought', route.get('booking_number'))

      $.ajax({
        url: $(this).attr('action'),
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        cache: false,
      }).done((res) => {
        if (res.response.payment_url) {
          location.href = res.response.payment_url;
        }

        // $(el.payment).show();
        // $(this).hide();
      }).catch(xhr => {
        const response = xhr.responseJSON;
        if(response.message) {
          alert(response.message);
        }

        if(response.errors) {
          $(this).find('input.invalid').removeClass('invalid');
          $(this).find('FormField.invalid').removeClass('invalid');
          $(this).find('.FormField__Helper').remove();
          $(this).removeClass('Form--Validated');
          
          const $form = $(this);
          $.each(response.errors, (key, message) => {
            $(this).addClass('Form--Validated');
            const $element = $form.find(`input[name=${key}]`);
            $element.addClass('invalid');
            $element.closest('FormField').addClass('invalid');
            $element.after(`<span class="FormField__Helper">${message}</span>`)
          })
        }
      })

    });

    onInput(el.main);
  };

  const executeBack = () => {
    const el = {
      form: ".js-booking-form",
      detail: ".js-booking-detail",
      btn: ".js-booking-form-click",
      step: ".js-booking-step",
      payment: ".js-booking-form-payment",
    };
    if ($(el.btn).length === 0) return;

    $(document).on("click", el.btn, function (e) {
      e.preventDefault();
      const to = $(this).data("to");
      const detailTitle = $(`${el.detail} .js-booking-detail_title`).data(to);

      $(this).attr("data-step_value", to);
      $(`${el.detail} .js-booking-detail_title`).text(detailTitle);

      const stepValue = $(this).data("value_step");
      const stepChecked = $(this).data("value_checked");

      $(el.step).attr("aria-valuetext", stepValue);
      $(el.step).attr("aria-checked", stepChecked);

      // $(el.payment).hide();
      // $(el.form).show();
    });
  };

  init();
};

try {
  componentBookingForm();
} catch (error) {
  console.error("utilsSwiper", error);
}
